import React, { Component } from 'react';
import { Modal, Spin, Row, Col, Input, Select, Button, InputNumber, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const { Option } = Select;

class SetAgainst extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        compareBasicList: [],
    }

    record = {}
    
    show = record => {
        this.record = record;

        this.setState({
            data: {},
            visible: true,
        }, () => {
            this.queryAgainst();
            this.queryCompareBasicList();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    queryAgainst = () => {
        const { visitTypeId } = this.record;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitViolateByVisitTypeId,
            data: { visitTypeId, },
            dataType: 'json',
            doneResult: (res) => {
                const { data } = this.state;
                const { comments, rangeDay, comparison, referentVisitTypeId, visitViolateId } = res.visitViolate || {};
                data.comments = comments;
                data.rangeDay = rangeDay;
                data.comparison = comparison;
                data.referentVisitTypeId = referentVisitTypeId;
                data.visitViolateId = visitViolateId;

                this.setState({
                    data,
                    loading: false,
                }, () => {
                    this.queryCompareBasicList();
                });
            },
        });
    }

    queryCompareBasicList = () => {
        const { visitGroupingId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.visitTypeDataList,
            data: { visitGroupingId, publishStatus: 'ALL' },
            dataType: 'json',
            doneResult: res => {
                this.setState({ compareBasicList: res.data.visitTypeList || [] });
            },
        });
    }

    reset = () => {
        const { data: { visitViolateId } } = this.state;
        if (!visitViolateId) {
            return message.warning('尚未设置违背规则!');
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.delVisitViolate,
            data: { visitViolateId },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({
                    data: {},
                    loading: false,
                });
            },
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }
    
    handleSubmit = () => {
        const { visitTypeId } = this.record;
        const { data } = this.state;
        const { visitViolateId, comments, comparison, referentVisitTypeId, rangeDay } = data;
        if (!comments) {
            return message.warning('违背原因描述不能为空!');
        }
        if (!comparison) {
            return message.warning('请选择比较符号');
        }
        if (!referentVisitTypeId) {
            return message.warning('请选择对照访视');
        }
        if (rangeDay === undefined || rangeDay === null || rangeDay === '') {
            return message.warning('请填写天数');
        }
        const url = !visitViolateId ? API_URL.plan.addVisitViolate : API_URL.plan.modifyVisitViolate;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url,
            data: {
                visitViolateId,
                visitTypeId,
                comments,
                comparison: comparison || '',
                referentVisitTypeId: referentVisitTypeId || '',
                rangeDay: rangeDay || '',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    render() {
        const { visitTypeName } = this.record;
        const { visible, loading, data, compareBasicList } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const compareBasicOptions = compareBasicList.map(i => <Option key={i.visitTypeId}>{i.visitTypeName}</Option>);
        return (
            <Modal
                title="设置违背规则"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div style={{ lineHeight: '40px' }}>
                        <Row>
                            <Col span={7} style={{textAlign: 'right'}}>违背判断对象:</Col>
                            <Col span={8} offset={1} style={{textAlign: 'center'}}>{visitTypeName}</Col>
                            <Col span={6} offset={2}>
                                <Button type='primary' onClick={this.reset}>重置规则</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={7} style={{textAlign: 'right'}}>{asterisk}违背原因描述:</Col>
                            <Col span={16} offset={1}>
                                <Input
                                    placeholder='请输入'
                                    value={data.comments}
                                    onChange={e => this.handleChange(e.target.value, 'comments')}
                                />
                            </Col>
                        </Row>
                        <Row style={{ paddingLeft: 30 }}>本访视若满足如下条件，则本访视违背方案:</Row>
                        <Row>
                            <Col span={5} style={{textAlign: 'center'}}>{visitTypeName}</Col>
                            <Col span={19}>
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{width: 80, marginRight: 6 }}
                                    value={data.comparison}
                                    onChange={value => this.handleChange(value, 'comparison')}
                                >
                                    <Option value='LT'>&lt;</Option>
                                    <Option value='LT_EQ'>&lt;=</Option>
                                    <Option value='GT'>&gt;</Option>
                                    <Option value='GT_EQ'>&gt;=</Option>
                                </Select>
                                <Select
                                    style={{width: 90}}
                                    placeholder="请选择"
                                    value={data.referentVisitTypeId ? String(data.referentVisitTypeId) : undefined}
                                    onChange={value => this.handleChange(value, 'referentVisitTypeId')}
                                >
                                    {compareBasicOptions}
                                </Select>
                                <span style={{ margin: '0 6px' }}>+</span>
                                <InputNumber
                                    style={{width: 60}}
                                    min={0}
                                    precision={0}
                                    placeholder='请输入'
                                    value={data.rangeDay}
                                    onChange={value => this.handleChange(value, 'rangeDay')}
                                />
                                <span style={{ marginLeft: 6 }}>天</span>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default SetAgainst;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/SetAgainst.js